// js/utils/modal.js

/**
 * Cria e exibe um modal de confirmação genérico no DOM.
 * @param {string} title - O título do modal.
 * @param {string} message - A mensagem de confirmação (aceita HTML).
 * @param {function} onConfirm - A função a ser executada se o usuário confirmar.
 */
export function showConfirmationModal(title, message, onConfirm) {
    document.querySelector('.confirmation-modal-overlay')?.remove();

    const modalHTML = `
        <div class="confirmation-modal-overlay">
            <div class="confirmation-modal">
                <h3>${title}</h3>
                <p>${message}</p>
                <div class="confirmation-modal-actions">
                    <button class="btn btn-secondary" id="modal-cancel-btn">Cancelar</button>
                    <button class="btn btn-danger" id="modal-confirm-btn">Confirmar</button>
                </div>
            </div>
        </div>
    `;
    
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    
    const overlay = document.querySelector('.confirmation-modal-overlay');
    const confirmBtn = document.getElementById('modal-confirm-btn');
    const cancelBtn = document.getElementById('modal-cancel-btn');

    const closeModal = () => {
        overlay.classList.remove('visible');
        setTimeout(() => overlay.remove(), 300);
    };

    confirmBtn.addEventListener('click', () => {
        onConfirm();
        closeModal();
    });

    cancelBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
            closeModal();
        }
    });

    setTimeout(() => overlay.classList.add('visible'), 10);
}
